import { Parser } from "@siteimprove/alfa-parser";
import { Selective } from "@siteimprove/alfa-selective";
import { Value } from "../value.js";
import { URL } from "../textual/url.js";
import { Gradient } from "./gradient/index.js";
const { map, either } = Parser;
/**
 * {@link https://drafts.csswg.org/css-values/#images}
 *
 * @public
 */
export class Image extends Value {
    static of(image) {
        return new Image(image);
    }
    _image;
    constructor(image) {
        super("image", Value.hasCalculation(image));
        this._image = image;
    }
    get image() {
        return this._image;
    }
    resolve(resolver) {
        return new Image(this._image.resolve(resolver));
    }
    partiallyResolve(resolver) {
        return Image.of(Selective.of(this._image)
            .if(URL.isURL, (url) => url.resolve())
            .else((gradient) => gradient.partiallyResolve(resolver))
            .get());
    }
    equals(value) {
        return value instanceof Image && value._image.equals(this._image);
    }
    hash(hash) {
        hash.writeHashable(this._image);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            image: this._image.toJSON(),
        };
    }
    toString() {
        return `${this._image}`;
    }
}
/**
 * @public
 */
(function (Image) {
    function isImage(value) {
        return value instanceof Image;
    }
    Image.isImage = isImage;
    /**
     * {@link https://drafts.csswg.org/css-images/#typedef-image}
     */
    Image.parse = map(either(URL.parse, Gradient.parse), Image.of);
})(Image || (Image = {}));
//# sourceMappingURL=image.js.map